import classNames from 'classnames';
import { FormattedDate } from 'react-intl';

import Text from '../../../Text/Text';
import { DateOption } from '../../NearestDatesPicker';

import determineMonthWidths from './helpers/determineMonthWidths';

import styles from './MonthLabels.module.css';

type MonthLabelsProps = {
    dates: Array<DateOption>;
    timeZone: string;
    buttonWidth: number;
    buttonSpacing: number;
};

const MonthLabels = ({
    dates,
    timeZone,
    buttonWidth,
    buttonSpacing,
}: MonthLabelsProps) => {
    const months = determineMonthWidths({
        dates: dates,
        widthPerDate: buttonWidth,
        spacing: buttonSpacing,
    });

    return (
        <div className={classNames(styles.Root, styles.withPreFader)}>
            {months.map(({ month, width }) => (
                <div
                    style={{ width: width, marginRight: buttonSpacing }}
                    className={styles.LabelContainer}
                    key={month.toString()}
                >
                    <Text
                        size="small"
                        subdued
                        className={styles.MonthLabel}
                        wordBreak="normal"
                        hideOverflow
                    >
                        <FormattedDate
                            value={month.toDate(timeZone)}
                            month="long"
                        />
                    </Text>
                </div>
            ))}
        </div>
    );
};

export default MonthLabels;
